var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftCircleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 44.5,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-180 44.5 44.5)",
    fill: "black",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 44.5,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-180 44.5 44.5)",
    stroke: "#EEF1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.602 33.2323L17.0092 23.5397L26.7018 13.9469",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftCircleAlt);
export default __webpack_public_path__ + "static/media/chevron-left-circle-alt.f062c4406a431168301c534f5cd36b64.svg";
export { ForwardRef as ReactComponent };